import { render, staticRenderFns } from "./AIFeedback.vue?vue&type=template&id=3c14d499&scoped=true&"
import script from "./AIFeedback.vue?vue&type=script&lang=js&"
export * from "./AIFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AIFeedback.vue?vue&type=style&index=0&id=3c14d499&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c14d499",
  null
  
)

export default component.exports